import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"package-add,delivery"} maskId="square-filled-radius-0-stroke-1-IconPackageAdd"><path d="M3 21V3H8V9H16V3H21V13H17V16H14V19H17V21H3Z" fill="currentColor"/><path d="M15 3H9V8H15V3Z" fill="currentColor"/><path d="M19 17V14H18V17H15V18H18V21H19V18H22V17H19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPackageAdd;
